/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import Globals from "../shared/Globals";
import Icon from "./Icon";
import { ImageGalleryOverlayGlobal } from "./ImageGalleryOverlay";
import BaseCom from "./BaseCom";
import { qreq } from "../shared/qrequest";


export default class ImageGallery extends BaseCom {
    constructor(props) {
        super(props);

        this.state = {
            list: []
        };

        this.uploadRef = React.createRef();
        this.uploadCameraRef = React.createRef();
    }

    componentDidMount() {
        this.setState({ list: this.props.list });
    }

    componentDidUpdate(prevProps) {
        if (this.props.list !== prevProps.list)
            this.setState({ list: this.props.list });
    }

    showImageGallery = (i) => {
        if (!this.state.list || this.state.list.length === 0) return;
        let images = this.filterImageGallery([...this.state.list]);
        images.forEach(i => i.url = i.base64Content ? 'data:' + i.mimeType + ';base64,' + i.base64Content : Globals.serverUrl + '/api/storage/image/' + i.fileIdent);
        if (images.length === 0) return;
        ImageGalleryOverlayGlobal.show(images, (images, index) => this.deleteWoundImage(i, images, index));
    }

    deleteWoundImage = (i) => {
        let list = [...this.state.list];
        let z = list.findIndex(x => x.masterID === i.masterID);
        if (z >= 0)
            list.splice(z, 1);

        this.setState({ list });

        this.props.onChange?.(list);
    }

    filterImageGallery = (images) => {
        if (!images || !images.filter) return [];
        return images.filter(i => i.base64Content || i.fileIdent);
    }

    triggerUploadPhoto = (i, useCamera) => {
        this.setState({ item: i });
        if (useCamera)
            this.uploadCameraRef.current.click();
        else
            this.uploadRef.current.click();
    }

    resetPhotos = () => {
        let list = [];
        this.setState({ list });
        this.props.onChange?.(list);
    }


    uploadPhoto = (e) => {
        this.setState({ uploading: true });
        var reader = new FileReader();
        reader.readAsBinaryString(e.target.files[0]);
        reader.onload = () => {
            var b64data = btoa(reader.result);
            var item = { ...this.state.item };
            item.fileName = e.target.files[0].name;
            item.mimeType = e.target.files[0].type;
            item.dataSize = e.target.files[0].size;
            item.base64Content = b64data;
            if (!item.images) item.images = [];
            item.images.splice(0, 0, { displayFileName: item.fileName, mimeType: item.mimeType, base64Content: item.base64Content });


            this.uploadRef.current.value = '';


            this.doUpload(item);
        };
        reader.onerror = (error) => {
            console.log('Error: ', error);
            this.setState({ uploading: false });
            e.target.value = '';
        };

    }


    doUpload = async (item) => {
        try {
            let j = await qreq.postAsync('/api/storage/upload-encoded', item);
            if (j.item) {
                let list = [...this.state.list];
                list.push(j.item);
                this.setState({ list });

                this.props.onChange?.(list);

            }
            else
                this.alert(j.errorMessage);

            this.setState({ uploading: false });

        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }
    render() {
        const list = this.state.list;
        let i = null;
        if (list.length > 0)
            i = list[0];
        return (
            <div>
                <input type="file" className="d-none" ref={this.uploadCameraRef} accept="image/*" capture="camera" onChange={this.uploadPhoto} />
                <input type="file" className="d-none" ref={this.uploadRef} accept="image/*" onChange={this.uploadPhoto} />
                {this.state.uploading && <span>uploading please wait...</span>}
                {i && <div className="d-flex justify-content-center">
                    <div role="button" onClick={() => this.showImageGallery(i)}>
                        {i.base64Content ? <img src={'data:' + i.mimeType + ';base64,' + i.base64Content} alt="" className="img-fluid card-img-top" />
                            : i.fileIdent ? <img src={Globals.serverUrl + '/api/storage/image/' + i.fileIdent} className="img-fluid card-img-top" alt="" />
                                : <img src="/img/placeholder.png" className="img-fluid card-img-top" alt="" />}
                    </div>
                </div>}
                {this.filterImageGallery(list)?.length > 0 && <div className="mt-1 text-center fst-italic">{this.filterImageGallery(list).length} images</div>}
                {!this.props.disabled && <div className="mt-1">
                    <button type="button" className="btn btn-primary d-inline-block d-md-none" onClick={() => this.triggerUploadPhoto(i, true)} disabled={this.props.disabled}><Icon icon="faCamera" /> Take Photo</button>
                    <button type="button" className="btn btn-primary" onClick={() => this.triggerUploadPhoto(i, false)} disabled={this.props.disabled}><Icon icon="faUpload" /> Upload Photo</button>
                    <button type="button" className="btn btn-danger" onClick={() => this.resetPhotos(i)} disabled={this.props.disabled}>Reset</button>
                </div>}
            </div>
        );
    }
}